import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import storage from "redux-persist/lib/storage";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  createTransform,
  persistReducer,
  persistStore,
} from "redux-persist";
import { AuthUser } from "./reducer";

const reducer = {
  AuthUser,
};

const rootReducer = combineReducers(reducer);

/** Never persist tokens in Redux storage — only `data` (tokens use `lib/api` keys). */
const authUserPersistTransform = createTransform(
  (inboundState) => ({ data: inboundState?.data ?? {} }),
  (outboundState) => ({ data: outboundState?.data ?? {} }),
  { whitelist: ["AuthUser"] }
);

const persistConfig = {
  key: "root",
  storage,
  transforms: [authUserPersistTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const PERSIST_ACTIONS = [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER];
const logger = createLogger({
  collapsed: true,
  predicate: (_getState, action) => !PERSIST_ACTIONS.includes(action.type),
});

let middleware = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: { ignoredActions: PERSIST_ACTIONS },
  }).concat(logger);

if (process.env.NODE_ENV === "production") {
  middleware = (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: { ignoredActions: PERSIST_ACTIONS },
    });
}

export const store = configureStore({
  reducer: persistedReducer,
  middleware,
});

export const persistor = persistStore(store);
